import React from 'react'
import PropTypes from 'prop-types'
import { Card, Image, Transition } from 'semantic-ui-react'
import DrawingTool from './qr/DrawingTool'
import generateACNLQR from './qr/ACNLQRGenerator'
import '../styles/TeeKOQRCode.css'

export class TeeKOQRCode extends React.Component {
    constructor(props) {
        super(props)
        // Make a DrawingTool and ACNLQRGenerator
        
        // shirt
        //     drawing object
        //         artist object
        //             avatar string
        //             name string
        //         lines array of objects
        //             points array
        //                 x int
        //                 y int
        //             thickness int
        //             color string
        //         background string
        //     slogan object
        //         slogan string
        //         author
        //             name
        //     designer object
        //         name
        // const canvas = document.createElement('canvas')
        // canvas.width = 300
        // canvas.height = 300
        // this.canvas = canvas
        // this.state = {
        //     sketchOptions: {
        //         minThickness: 0.3,
        //         thicknessFactor: 0.0,
        //         smoothingFactor: 0.55,
        //         thicknessSmoothingFactor: 0.6,
        //         dotMultiplier: 2,
        //         tipTaperFactor: 0.7
        //     },
        //     shirtDataURL: '',
        //     qrDataURL: ''
        // }
        let sketchOptions = props.sketchOptions || {
            minThickness: 0.5,
            thicknessFactor: 0.1,
            smoothingFactor: 0.55,
            thicknessSmoothingFactor: 0.6,
            tipTaperFactor: 0.7,
            cappedEnds: false,
            borderWidth: 2,
            dotMultiplier: 2
        }

        this.canvas = document.createElement('canvas')
        this.canvas.width = 300
        this.canvas.height = 300
        this.tipCanvas = document.createElement('canvas')
        this.tipCanvas.width = this.canvas.width
        this.tipCanvas.height = this.canvas.height

        this.startX = null
        this.startY = null
        this.smoothedMouseX = null
        this.smoothedMouseY = null
        this.lastSmoothedMouse = {}
        this.lastMouse = {}

        this.redraw = this.redraw.bind(this)

        this.state = {
            sketchOptions,
            generatedQR: null,
            smallCanvas: null,
            visible: false
        }

    }

    componentDidMount() {
        this.redraw()
        this.setState({
            visible: true
        })
    }

    componentDidUpdate(prevProps) {
        if(this.props.lines !== prevProps.lines) {
            this.redraw()
        }
    } 

    redraw() {
        const { shirt } = this.props
        // Make a Drawing Tool and set metadata
        this.drawingTool = new DrawingTool()
        this.drawingTool.patternType = 4
        this.drawingTool.title = shirt.slogan.slogan.substr(0, 20)
        this.drawingTool.creator = shirt.designer.name.substr(0, 9)
        this.drawingTool.town = "Tee Shirt"

        // Make the shirt design
        const ctx = this.canvas.getContext('2d')
        const lines = shirt.drawing.lines
        ctx.clearRect(0,0,this.canvas.width, this.canvas.height)
        ctx.save()
        ctx.fillStyle = shirt.drawing.background
        ctx.fillRect(0, 0, this.canvas.width, this.canvas.height)
        ctx.restore()
        lines.forEach((line) => {
            this.drawLine(line)
        })

        // Get the drawing tool palette using quantize method
        const smallCanvas = this.createQRCanvas(this.canvas, shirt.drawing.background)
        this.imageQuantize(smallCanvas.getContext('2d').getImageData(0, 0, smallCanvas.width, smallCanvas.height))

        // this.drawingTool.load(this.canvas.toDataURL())
        const generatedQR = generateACNLQR(this.drawingTool)
        this.setState({
            generatedQR,
            smallCanvas
        })
    }

    createQRCanvas(canvas, background) {
        const width = 64
        const height = 64
        let newCanvas = document.createElement('canvas')
        newCanvas.width = width
        newCanvas.height = height

        let ctx = newCanvas.getContext('2d')
        // Draw the background
        ctx.save()
        ctx.fillStyle = background
        ctx.fillRect(0, 0, width, height)
        ctx.restore()

        // Draw the drawing onto 2, 2, 28, 28
        ctx.drawImage(canvas, 
            0, 0, canvas.width, canvas.height,
            3, 1, 26, 26
        )
        return newCanvas
    }

    imageQuantize(imgdata){
        let pixelCount = this.drawingTool.pixelCount * 4
        let pixels = []
        for (let i = 0; i < pixelCount; i+=4){
            if (imgdata.data[i+3] < this.convert_trans){continue}
            pixels.push({r:imgdata.data[i], g:imgdata.data[i+1], b:imgdata.data[i+2]})
        }
        const medianCut = (pixels) => {
            let l = Math.floor(pixels.length/2)
            let r_min = null; let r_max = null
            let g_min = null; let g_max = null
            let b_min = null; let b_max = null
            for (let i in pixels){
                if (pixels[i].r < r_min || r_min === null){r_min = pixels[i].r}
                if (pixels[i].r > r_max || r_max === null){r_max = pixels[i].r}
                if (pixels[i].g < g_min || g_min === null){g_min = pixels[i].g}
                if (pixels[i].g > g_max || g_max === null){g_max = pixels[i].g}
                if (pixels[i].b < b_min || b_min === null){b_min = pixels[i].b}
                if (pixels[i].b > b_max || b_max === null){b_max = pixels[i].b}
            }
            let r_dist = r_max-r_min
            let g_dist = g_max-g_min
            let b_dist = b_max-b_min
            if (r_dist >= g_dist && r_dist >= b_dist){
                //Sort on red
                pixels.sort((a,b)=>(a.r-b.r))
            }else if(g_dist >= r_dist && g_dist >= b_dist){
                //Sort on green
                pixels.sort((a,b)=>(a.g-b.g))
            }else{
                //Sort on blue
                pixels.sort((a,b)=>(a.b-b.b))
            }
            return [pixels.slice(0, l),pixels.slice(l)]
        }
        const medianMultiCut = (buckets) => {
            let res = []
            for (let i in buckets){
                const newBuck = medianCut(buckets[i])
                if (newBuck[0].length){res.push(newBuck[0])}
                if (newBuck[1].length){res.push(newBuck[1])}
            }
            return res
        }
        let buckets = medianCut(pixels)//creates 2 buckets
        buckets = medianMultiCut(buckets)//splits into 4
        buckets = medianMultiCut(buckets)//splits into 8
        buckets = medianMultiCut(buckets)//splits into 16

        //Now we have 16 buckets.
        let colors = []
        let uniqCol = new Set()

        //Pushes average color of given bucket onto colors.
        const pushAvg = (b) => {
            let r_avg = 0
            let g_avg = 0
            let b_avg = 0
            for (let i in b){
                r_avg += b[i].r
                g_avg += b[i].g
                b_avg += b[i].b
            }
            let rgb = [Math.round(r_avg/b.length), Math.round(g_avg/b.length), Math.round(b_avg/b.length)]
            let idx = this.drawingTool.findRGB(rgb)
            if (!uniqCol.has(idx)){
                colors.push(idx)
                uniqCol.add(idx)
            }
        }

        //Average the insides for colors.
        for (let i in buckets){pushAvg(buckets[i])}
        // console.log("Unique colors: "+uniqCol.size);

        if (uniqCol.size < 15){
        //We could add more colors. Quantize some more and cross fingers!
            buckets = medianMultiCut(buckets)//splits into 32
            for (let i in buckets){pushAvg(buckets[i])}
            // console.log("Unique colors after further quantize: "+uniqCol.size);
            if (uniqCol.size < 15){
                buckets = medianMultiCut(buckets)//splits into 64
                for (let i in buckets){pushAvg(buckets[i])}
                // console.log("Unique colors after further quantize: "+uniqCol.size);
                if (uniqCol.size < 15){
                    buckets = medianMultiCut(buckets)//splits into 128
                    for (let i in buckets){pushAvg(buckets[i])}
                    // console.log("Unique colors after further quantize: "+uniqCol.size);
                }
            }
        }else if (uniqCol.size > 15){
        //We have 16 colors (one for each bucket)
        //Find the closest two colors and merge them
            let minDist = 255*255*3
            let bucketA = null
            let bucketB = null
            for (let i in colors){
                for (let j in colors){
                    if (i >= j){continue}
                    let rD = (colors[i][0] - colors[j][0])
                    let gD = (colors[i][1] - colors[j][1])
                    let bD = (colors[i][2] - colors[j][2])
                    let match = (rD*rD + gD*gD + bD*bD)
                    if (match < minDist){
                        minDist = match
                        bucketA = i
                        bucketB = j
                    }
                }
            }
            //Merge bucket A and B into C
            let bucketC = buckets[bucketA].concat(buckets[bucketB])
            colors.splice(bucketB)//Must remove B first, since B is guaranteed to be the latter entry
            colors.splice(bucketA)//Now we can remove A too, since it was before B and thus couldn't have shifted
            pushAvg(bucketC)
            uniqCol = new Set(colors)
        // console.log("Unique colors after merge of closest two: "+uniqCol.size);
        }

        //Set palette to chosen colors
        let cNum = 0
        for (let c of uniqCol){
            if (cNum > 14){break}
            // console.log("Setting color "+cNum+" to "+c);
            this.drawingTool.setPalette(cNum, c)
            cNum++
        }

        //Set each pixel to the nearest color from the palette
        for (let i = 0; i < pixelCount; i+=4){
            let x = (i >> 2) % this.drawingTool.width
            let y = Math.floor((i >> 2) / this.drawingTool.width)
            if (imgdata.data[i+3] < this.convert_trans){
                this.drawingTool.setPixel(x, y, 15)
            }else{
                this.drawingTool.setPixel(x, y, [imgdata.data[i], imgdata.data[i+1], imgdata.data[i+2]])
            }
        }
        this.drawingTool.onLoad()
    }

    // Smooth Drawing functions
    startLineInContext(thickness, x, y) {
        const { sketchOptions } = this.state
        let ctx = this.canvas.getContext('2d')
        let tipCtx = this.tipCanvas.getContext('2d')
        const dotRadius = thickness * sketchOptions.minThickness
        tipCtx.beginPath()
        tipCtx.arc(x, y, dotRadius * sketchOptions.dotMultiplier, 0, 2 * Math.PI, true)
        tipCtx.closePath()
        tipCtx.fill()
        tipCtx.stroke()

        if (sketchOptions.cappedEnds) {
            ctx.drawImage(tipCtx.canvas, 0, 0)
        }

        this.lastMouseChangeVector = { x:0, y:0 }

        this.startX = this.lastMouse.x = this.smoothedMouseX = this.lastSmoothedMouse.x = x
        this.startY = this.lastMouse.y = this.smoothedMouseY = this.lastSmoothedMouse.y = y
        this.lastThickness = dotRadius
        this.lastRotation = undefined
        this.colorLevel = 0
    }

    continueLineInContext(thickness, x, y) {
        const { sketchOptions } = this.state
        let ctx = this.canvas.getContext('2d')
        let tipCtx = this.tipCanvas.getContext('2d')
        let mouseChangeVectorX = x - this.lastMouse.x
        let mouseChangeVectorY = y - this.lastMouse.y

        //Cusp detection - if the mouse movement is more than 90 degrees
        //from the last motion, we will draw all the way out to the last
        //mouse position before proceeding.  We handle this by drawing the
        //previous tipLayer, and resetting the last smoothed mouse position
        //to the last actual mouse position.
        //We use a dot product to determine whether the mouse movement is
        //more than 90 degrees from the last motion.
        if (
            mouseChangeVectorX * this.lastMouseChangeVector.x +
                mouseChangeVectorY * this.lastMouseChangeVector.y <
            0
        ) {
            if (tipCtx) ctx.drawImage(tipCtx.canvas, 0, 0)
            this.smoothedMouseX = this.lastSmoothedMouse.x = this.lastMouse.x
            this.smoothedMouseY = this.lastSmoothedMouse.y = this.lastMouse.y
            this.lastRotation += Math.PI
            this.lastThickness =
                sketchOptions.tipTaperFactor * this.lastThickness
        }

        //We smooth out the mouse position.  The drawn line will not extend to the current mouse position; instead
        //it will be drawn only a portion of the way towards the current mouse position.  This creates a nice
        //smoothing effect.
        this.smoothedMouseX =
            this.smoothedMouseX +
            sketchOptions.smoothingFactor * (x - this.smoothedMouseX)
        this.smoothedMouseY =
            this.smoothedMouseY +
            sketchOptions.smoothingFactor * (y - this.smoothedMouseY)

        //We determine how far the mouse moved since the last position.  We use this distance to change
        //the thickness and brightness of the line.
        const dx = this.smoothedMouseX - this.lastSmoothedMouse.x
        const dy = this.smoothedMouseY - this.lastSmoothedMouse.y
        const dist = Math.sqrt(dx * dx + dy * dy)

        let lineRotation
        if (dist !== 0) {
            lineRotation = Math.PI / 2 + Math.atan2(dy, dx)
        } else {
            lineRotation = 0
        }

        //We use a similar smoothing technique to change the thickness of the line, so that it doesn't
        //change too abruptly.
        let targetLineThickness =
            sketchOptions.minThickness * thickness +
            sketchOptions.thicknessFactor * dist
        let lineThickness =
            this.lastThickness +
            sketchOptions.thicknessSmoothingFactor *
                (targetLineThickness - this.lastThickness)

        /*
        The "line" being drawn is actually composed of filled in shapes.  This is what allows
        us to create a varying thickness of the line.
        */
        if (this.lastRotation === undefined) this.lastRotation = lineRotation
        let sin0 =
            this.lastRotation !== null
                ? Math.sin(this.lastRotation)
                : Math.sin(lineRotation)
        let cos0 =
            this.lastRotation !== null
                ? Math.cos(this.lastRotation)
                : Math.sin(lineRotation)
        let sin1 = Math.sin(lineRotation)
        let cos1 = Math.cos(lineRotation)
        let L0Sin0 = this.lastThickness * sin0
        let L0Cos0 = this.lastThickness * cos0
        let L1Sin1 = lineThickness * sin1
        let L1Cos1 = lineThickness * cos1

        let controlVecX = 0.33 * dist * sin0
        let controlVecY = -0.33 * dist * cos0
        let controlX1 = this.lastSmoothedMouse.x + L0Cos0 + controlVecX
        let controlY1 = this.lastSmoothedMouse.y + L0Sin0 + controlVecY
        let controlX2 = this.lastSmoothedMouse.x - L0Cos0 + controlVecX
        let controlY2 = this.lastSmoothedMouse.y - L0Sin0 + controlVecY

        ctx.beginPath()
        ctx.moveTo(
            this.lastSmoothedMouse.x + L0Cos0,
            this.lastSmoothedMouse.y + L0Sin0
        )
        ctx.quadraticCurveTo(
            controlX1,
            controlY1,
            this.smoothedMouseX + L1Cos1,
            this.smoothedMouseY + L1Sin1
        )
        ctx.lineTo(
            this.smoothedMouseX - L1Cos1,
            this.smoothedMouseY - L1Sin1
        )
        ctx.quadraticCurveTo(
            controlX2,
            controlY2,
            this.lastSmoothedMouse.x - L0Cos0,
            this.lastSmoothedMouse.y - L0Sin0
        )
        ctx.closePath()
        ctx.fill()
        ctx.stroke()

        //round tip:
        let taperThickness = sketchOptions.tipTaperFactor * lineThickness
        tipCtx.clearRect(0, 0, tipCtx.canvas.width, tipCtx.canvas.height)
        tipCtx.beginPath()
        tipCtx.arc(x, y, taperThickness, 0, 2 * Math.PI, true)
        tipCtx.closePath()
        tipCtx.fill()
        tipCtx.stroke()

        //quad segment
        tipCtx.beginPath()
        tipCtx.moveTo(
            this.smoothedMouseX + L1Cos1,
            this.smoothedMouseY + L1Sin1
        )
        tipCtx.lineTo(
            x + sketchOptions.tipTaperFactor * L1Cos1,
            y + sketchOptions.tipTaperFactor * L1Sin1
        )
        tipCtx.lineTo(
            x - sketchOptions.tipTaperFactor * L1Cos1,
            y - sketchOptions.tipTaperFactor * L1Sin1
        )
        tipCtx.lineTo(
            this.smoothedMouseX - L1Cos1,
            this.smoothedMouseY - L1Sin1
        )
        tipCtx.closePath()
        tipCtx.fill()
        tipCtx.stroke()

        this.lastSmoothedMouse = {
            x: this.smoothedMouseX,
            y: this.smoothedMouseY
        }
        this.lastRotation = lineRotation
        this.lastThickness = lineThickness
        this.lastMouseChangeVector = {
            x: mouseChangeVectorX,
            y: mouseChangeVectorY
        }
        this.lastMouse = { x: x, y: y }
    }

    drawLine(line) {
        const { sketchOptions } = this.state
        let ctx = this.canvas.getContext('2d')
        let points = line.points
        let tipCanvas = this.tipCanvas
        let tipCtx = this.tipCanvas.getContext('2d')

        let thickness = line.thickness
        ctx.strokeStyle = line.color
        ctx.lineWidth = sketchOptions.borderWidth
        ctx.lineCap = 'round'
        ctx.lineJoin = 'bevel'
        ctx.fillStyle = line.color
        ctx.strokeStyle = line.color
        ctx.globalCompositeOperation = (line.highlighter) ? 'destination-over' : 'source-over'
        tipCtx.lineWidth = sketchOptions.borderWidth
        tipCtx.fillStyle = line.color
        tipCtx.strokeStyle = line.color

        if (typeof points === 'string') {
            points = line.points.split('|').map((point) => {
                return {
                    x: parseInt(point.split(',')[0]),
                    y: parseInt(point.split(',')[1])
                }
            })
        } else {
            points = points.map((point) => {
                return {
                    x: parseInt(point.x),
                    y: parseInt(point.y)
                }
            })
        }

        points.forEach((point, k) => {
            if (k === 0) {
                this.startLineInContext(thickness, point.x, point.y)
            } else {
                this.continueLineInContext(thickness, point.x, point.y)
            }
        })
        ctx.drawImage(tipCanvas, 0, 0)
    }

    render() {
        const { generatedQR, visible } = this.state

        return (
            <Transition visible={visible} animation='vertical flip' duration={500}>
                <Card fluid className="TeeKOQRCode">
                    <Image fluid className="Drawing" src={generatedQR} />
                </Card>
            </Transition>
        )
    }
}

TeeKOQRCode.propTypes = {
    shirt: PropTypes.object.isRequired,
    sketchOptions: PropTypes.object
}

